/**
 * @flow
 * @relayHash 52367b7756750fd5eb42868cb3fdd85c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type LinkList_viewer$ref = any;
export type UpdateCustomerLinkInput = {|
  clientMutationId: string,
  id: string,
  description: string,
  url: string,
|};
export type LinkListUpdateLinkMutationVariables = {|
  input: UpdateCustomerLinkInput
|};
export type LinkListUpdateLinkMutationResponse = {|
  +updateCustomerLink: ?{|
    +viewer: ?{|
      +$fragmentRefs: LinkList_viewer$ref
    |}
  |}
|};
export type LinkListUpdateLinkMutation = {|
  variables: LinkListUpdateLinkMutationVariables,
  response: LinkListUpdateLinkMutationResponse,
|};
*/


/*
mutation LinkListUpdateLinkMutation(
  $input: UpdateCustomerLinkInput!
) {
  updateCustomerLink(input: $input) {
    viewer {
      ...LinkList_viewer
      id
    }
  }
}

fragment LinkForm_link on CustomerLink {
  id
  description
  url
}

fragment LinkList_viewer on Customer {
  id
  name
  links {
    id
    url
    description
    ...LinkForm_link
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCustomerLinkInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LinkListUpdateLinkMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCustomerLink",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCustomerLinkPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "viewer",
            "storageKey": null,
            "args": null,
            "concreteType": "Customer",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "LinkList_viewer",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "LinkListUpdateLinkMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateCustomerLink",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCustomerLinkPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "viewer",
            "storageKey": null,
            "args": null,
            "concreteType": "Customer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "links",
                "storageKey": null,
                "args": null,
                "concreteType": "CustomerLink",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "LinkListUpdateLinkMutation",
    "id": null,
    "text": "mutation LinkListUpdateLinkMutation(\n  $input: UpdateCustomerLinkInput!\n) {\n  updateCustomerLink(input: $input) {\n    viewer {\n      ...LinkList_viewer\n      id\n    }\n  }\n}\n\nfragment LinkForm_link on CustomerLink {\n  id\n  description\n  url\n}\n\nfragment LinkList_viewer on Customer {\n  id\n  name\n  links {\n    id\n    url\n    description\n    ...LinkForm_link\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e0e9bbc3ac93da4d7e6852ecff6e7bc8';
module.exports = node;
